import React, { Component } from "react";
import AgencyTable from "../../components/AgencyTable/AgencyTable";
import Aux from "../../hoc/Auxilary";
import AgencyModal from "../../components/AgencyModal/AgencyModal";
import Modal from "../../hoc/UI/Modal/Modal";
import axiosInstance from "../../axios-project";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import swal from "sweetalert";


const confirmBeforeDelete = fn => {
  swal({
    title: "Are you sure?",
    text: "Once deleted, this operation cannot be undone!",
    icon: "warning",
    buttons: true,
    dangerMode: true
  }).then(willDelete => {
    if (willDelete) {
      fn();
    }
  });
};

class AgencyOverview extends Component {
  state = {
    agencyDetails: [],
    baseURL: "https://api.transportationprojects.org/api",
    showModal: false,
    showSmallModal: false,
    showEditModal: false,
    currentAgencyID: null,
    budget: [],
    agencyDocuments: [],
    mode: localStorage.getItem("mode") || 3,
    page: 0
  };

  changePage = p => {
    this.setState({
      page: p
    });
  };

  fetchAgencyDetails = () => {
    if (localStorage.getItem("role")) {
      let role = JSON.parse(localStorage.getItem("role")).map(
        role => role.name
      );
      axiosInstance
        .get("/agency")
        .then(response => {
          if (role.includes("ROLE_ADMIN")) {
            this.setState(prevState => {
              return {
                agencyDetails: response.data
              };
            });
          } else {
            axiosInstance
              .get("/user/me")
              .then(response2 => {
                if (response2.data.states) {
                  let states = response2.data.states.map(
                    state => state.state_id
                  );
                  console.log(states);
                  let agencies = [];
                  for (let i in response.data) {
                    if (states.includes(response.data[i].state_id)) {
                      agencies.push(response.data[i]);
                    }
                  }
                  this.setState(prevState => {
                    return {
                      agencyDetails: agencies
                    };
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  };

  fetchAgencyBudgetDetails = () => {
    axiosInstance
      .get("/agency_budget")
      .then(response => {
        this.setState({
          budget: response.data
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  componentDidMount() {
    this.fetchAgencyDetails();
    console.log(localStorage.getItem("mode"))
    // this.changeModeHandler(localStorage.getItem("mode") || 3);
  }

  closeModalHandler = () => {
    this.setState({
      showModal: false
    });
  };

  toggleModalHandler = agencyID => {
    this.fetchAgencyBudgetDetails();
    this.setState(prevState => {
      return {
        showModal: true,
        currentAgencyID: agencyID
      };
    });
  };

  createNewAgency = () => {
    this.setState({
      showModal: true,
      currentAgencyID: null,
      mode: 0
    });
  };

  changeModeHandler = modeID => {
    this.setState({
      mode: modeID
    });
    // console.log("mode" ,modeID)
    localStorage.setItem("mode", modeID)
  };

  updateAgencyDocuments = agencyID => {
    axiosInstance
      .get("/agency_file/" + agencyID)
      .then(response => {
        console.log("agencyDocuments", response.data);
        this.setState({
          agencyDocuments: response.data
        });
      })
      .catch(error => {
        this.setState({
          agencyDocuments: []
        });
        console.log(error);
      });
  };

  addDocumentsHandler = documentInfo => {
    axiosInstance
      .post("/agency_file", documentInfo)
      .then(response => {
        this.updateAgencyDocuments(documentInfo.agency_id);
      })
      .catch(error => {
        this.setState({
          agencyDocuments: []
        });
        console.log(error);
      });
  };

  updateAgencyDocuments = agencyID => {
    axiosInstance
      .get("/agency_file/agency_id/" + agencyID)
      .then(response => {
        this.setState({
          agencyDocuments: response.data
        });
      })
      .catch(error => {
        this.setState({
          agencyDocuments: []
        });
        console.log(error);
      });
  };

  addDocumentsHandler = documentInfo => {
    axiosInstance
      .post("/agency_file", documentInfo)
      .then(response => {
        this.updateAgencyDocuments(documentInfo.agency_id);
      })
      .catch(error => {
        this.setState({
          agencyDocuments: []
        });
        console.log(error);
      });
  };

  addBudgetHandler = budget => {
    axiosInstance
      .post("/agency_budget", budget)
      .then(response => {
        this.fetchBudget(budget.agency_id);
        this.setState({
          showSmallModal: false
        });
      })
      .catch(error => {
        this.setState({
          budget: []
        });
        console.log(error);
      });
  };

  updateBudgetHandler = budget => {
    axiosInstance
      .post("/agency_budget", budget)
      .then(response => {
        this.fetchBudget(budget.agency_id);
        this.setState({
          showSmallModal: false
        });
      })
      .catch(error => {
        this.setState({
          budget: []
        });
        console.log(error);
      });
  };

  deleteBudgetHandler = (budgetID, agencyID) => {
    confirmBeforeDelete(() =>
      axiosInstance
        .delete("./agency_budget/" + budgetID)
        .then(response => {
          this.fetchBudget(agencyID);
        })
        .catch(error => {
          this.setState({
            budget: []
          });
          console.log(error);
        })
    );
  };

  toggleSmallModalHandler = () => {
    this.setState(prevState => {
      return {
        showSmallModal: !prevState.showSmallModal
      };
    });
  };

  fetchBudget = agencyID => {
    axiosInstance
      .get("/agency_budget/agency_id/" + agencyID)
      .then(response => {
        this.setState({
          budget: response.data
        });
      })
      .catch(error => {
        this.setState({
          budget: []
        });
        console.log(error);
      });
  };

  submit = values => {
    console.log("submit", JSON.stringify(values));
    let url;
    switch (this.state.mode) {
      case 0:
        url = "/agency_draft";
        this.setState({
          mode: 1
        });
        break;
      case 1:
        if (values.agency_id)
          url = "/edit_draft_agency_and_submit/" + values.agency_id;
        break;
      case 2:
        url = "/audit_agency/" + values.agency_id;
        break;
      case 3:
        url = "/edit_published_agency/" + values.agency_id;
        break;
      default:
        break;
    }

    axiosInstance
      .post(url, values)
      .then(response => {
        this.closeModalHandler();
        this.fetchAgencyDetails();
      })
      .catch(error => {
        console.log(error);
        alert("Update Failed");
        this.closeModalHandler();
      });
  };

  render() {
    let modal = null;
    const role = localStorage.getItem("project_role");

    if (this.state.showModal) {
      modal = (
        <Modal>
          <AgencyModal
            closed={this.closeModalHandler}
            closeModalHandler={this.closeModalHandler}
            mode={this.state.mode}
            agencyItems={this.state.agencyDetails}
            shownItem={this.state.agencyDetails.find(
              a => a.agency_id === this.state.currentAgencyID
            )}
            currentAgencyID={this.state.currentAgencyID}
            submit={this.submit}
            budget={this.state.budget}
            getAgencyDocuments={agencyID =>
              this.updateAgencyDocuments(agencyID)
            }
            documents={this.state.agencyDocuments}
            addDocuments={this.addDocumentsHandler}
            showSmallModal={this.state.showSmallModal}
            toggleModalHandler={this.toggleModalHandler}
            toggleSmallModalHandler={this.toggleSmallModalHandler}
            fetchBudget={this.fetchBudget}
            addBudget={this.addBudgetHandler}
            updateBudget={this.updateBudgetHandler}
            deleteBudget={this.deleteBudgetHandler}
          />
        </Modal>
      );
    }

    return (
      <Aux>
        {modal}
        {this.state.showModal ? (
          ""
        ) : (
          <div>
            <div style={{ textAlign: "right" }}>
              <button
                className={"btn btn-outline-primary ml-auto btn-sm my-1 "}
                type="button"
                onClick={this.createNewAgency}
              >
                Create new Agency
              </button>
            </div>
            <Tabs selectedIndex={3 - this.state.mode}>
              <TabList>
                <Tab onClick={() => this.changeModeHandler(3)}>Published</Tab>

                {role === "ROLE_USER" ? null : (
                  <Tab onClick={() => this.changeModeHandler(2)}>
                    Pending Approval
                  </Tab>
                )}
                <Tab onClick={() => this.changeModeHandler(1)}> Draft</Tab>
              </TabList>

              <TabPanel></TabPanel>
              {role === "ROLE_USER" ? null : <TabPanel></TabPanel>}
              <TabPanel></TabPanel>
            </Tabs>
            <AgencyTable
              closeModalHandler={this.closeModalHandler}
              mode={this.state.mode}
              clicked={this.toggleModalHandler}
              agencyItems={this.state.agencyDetails}
              page={this.state.page}
              changePage={this.changePage}
            />
          </div>
        )}
      </Aux>
    );
  }
}

export default AgencyOverview;
